module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-10.60ce6224.jpg";